import { z } from "zod";

import { OrderDirection } from "@/constants/orderDirection";

const AlertCategory = {
  ALL: "ALL",
  DISABLED: "DISABLED",
  DATA_OVERAGE: "DATA_OVERAGE",
  PERFORMANCE_ISSUE: "PERFORMANCE_ISSUE",
  UPDATE: "UPDATE",
  ROUTER_ISSUE: "ROUTER_ISSUE",
  OTHERS: "OTHERS",
} as const;

export const AlertsTableFilterSchema = z.object({
  orderDirection: z
    .nativeEnum(OrderDirection)
    .default(OrderDirection.ASC)
    .optional(),
  sortColumn: z.string().optional(),
  page: z.number().default(1),
  pageSize: z.number().default(100),

  category: z.nativeEnum(AlertCategory).default(AlertCategory.ALL),
  freeText: z.string().optional(),
});

export type AlertCategory = (typeof AlertCategory)[keyof typeof AlertCategory];
